import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, MultiPromptTemplatesStore, type State } from './MultiPromptTemplatesStore';

export const useMultiPromptTemplateActions = createActionsHook<State, Actions>(
  MultiPromptTemplatesStore
);
